export default function LegalLayout({ title, children }) {
  return (
    <div className="mx-auto max-w-3xl px-4 sm:px-6 py-14 sm:py-20">
      <span className="text-xs font-bold uppercase tracking-[0.25em] text-yellow-500">Documento legale</span>
      <h1 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tighter">{title}</h1>
      <div className="mt-8 prose prose-invert max-w-none text-zinc-300 [&>h3]:text-white [&>h3]:mt-8 [&>h3]:mb-2 [&>p]:leading-relaxed [&_a]:text-yellow-400">
        {children}
      </div>
    </div>
  );
}
